import React, { useEffect, useRef, useState } from 'react';
import './Time.css';

const Time = () => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      {
        threshold: 0.3,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="time" ref={sectionRef} className={`time-section ${isVisible ? 'animate' : ''}`}>
      <div className="container text-center fade-in-up">
        <h2 className="mb-4">Horarios</h2>

        <div className="card border-light shadow-lg mb-3" style={{ maxWidth: '22rem', margin: '0 auto' }}>
          <div className="card-header bg-primary text-white d-flex justify-content-center align-items-center">
            <span style={{ fontSize: '1.5rem', marginRight: '10px' }}>🕒</span>
            <h5 className="mb-0">Horarios de trabajo</h5>
          </div>

          <div className="card-body bg-light">
            <h5 className="card-title">Lunes - Sábado</h5>
            <p className="card-text">8:00 a 18:00 hrs</p>
          </div>

          <div className="card-footer bg-primary text-white">
            <small>* Horario sujeto a cambios en días festivos</small>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Time;
